import { render, staticRenderFns } from "./depositRecord.vue?vue&type=template&id=7cdeed68&scoped=true"
import script from "./depositRecord.vue?vue&type=script&lang=js"
export * from "./depositRecord.vue?vue&type=script&lang=js"
import style0 from "./depositRecord.vue?vue&type=style&index=0&id=7cdeed68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdeed68",
  null
  
)

export default component.exports